export default {
  get constants() {
    return window.vp.configurator.constants;
  },
};
